<template>
  <header class="header">
    <div class="inner">
      <div class="logo">
        <router-link :to="'/'"><img :src="logoImage" :alt="logoTitle" /></router-link>
      </div>
      <div class="srch-account">
        <div class="m-search">
          <el-select ref='myselected' v-model="value" class="sr-select" id="selectHead" placeholder="请选择" :value="keys">
            <el-option v-for="(item, index) of optionList" :key="item.Id" :label="item.value" :value="item.Id">
            </el-option>
          </el-select>
          <input class="z-input" type="text" v-on:keyup.enter="goSearch" ref="searchTxt" v-model="inputvalue"
            placeholder="Please Input" />
          <span class="icon iconfont icon-sousuo" @click="goSearch()"></span>
        </div>

        <div class="m-account" v-if="userInfo.Id !== '3058'">
          <el-dropdown trigger="click">
            <div class="count-btn" v-if="userLogin">
              <span class="icon iconfont icon-yonghu"></span>
            </div>
            <div class="count-btn" v-else>
              <img :src="userImg" />
            </div>

            <el-dropdown-menu slot="dropdown" class="m-count-list">
              <template v-if="userLogin">
                <el-dropdown-item class="go-login">
                  <router-link :to="'/Login'">
                    <i class="el-icon-user"></i>
                    Log on
                  </router-link>
                </el-dropdown-item>
              </template>
              <template v-else>
                <el-dropdown-item class="c-item" v-show="accountShow">
                  <router-link class="c-link" :to="'/bookshelf'">
                    <span class="icon iconfont icon-tushuguan"></span>
                    <div class="c-name">Bookshelf</div>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item class="c-item" divided v-show="accountShow">
                  <router-link class="c-link" :to="'/account'">
                    <span class="icon iconfont icon-huiyuanzhanghu"></span>
                    <div class="c-name">My</div>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item class="c-item" divided v-show="accountShow">
                  <router-link class="c-link" :to="'/footprint'">
                    <span class="icon iconfont icon-caidanguanli"></span>
                    <div class="c-name">Reading</div>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item divided class="quit-login" @click.native="quitLogin">
                  <span class="icon iconfont icon-tuichu"></span> Log on
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="menu">
        <ul class="menu-list">
          <li class="item" v-for="(item, index) of list" :key="index">
            <template v-if="item.DHURL">
              <a :href="item.DHURL"> {{ item.COLUMNNAME }}</a>
            </template>
            <template v-else>
              <router-link :to="item.URL ? item.URL + (item.ID ? '/' + item.ID : '') : '/'">
                {{ item.COLUMNNAME }}
              </router-link>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import jwt_decode from "jwt-decode";
import axios from 'axios';
export default {
  name: "CommonHead",
  props: ["keys", "word"],
  data: function () {
    return {
      list: [
        { ID: "", COLUMNNAME: "HOME", URL: "/" },
        { ID: "", COLUMNNAME: "CATEGORY", URL: "/categry" },
      ],
      optionList: [
        { Id: "", value: "ALL" },
        { Id: "1", value: "Title" },
        { Id: "2", value: "Author" },
        { Id: "3", value: "Publisher" },
        { Id: "4", value: "ISBN" },
      ],
      userInfo: JSON.parse(localStorage.getItem("OrgInfo")),
      value: "",
      inputvalue: "",
      accountShow: false,
      userLogin: true,
      logoImage: require("@/assets/logo.png"),
      logoTitle: "bks",
      userImg: '/static/img/tx.jpg',

    };
  },
  async mounted() {
    await this.$onWait;
    //console.log(this.userInfo)
    this.loadColumnData();
    if (window.localStorage.Token !== "" && window.localStorage.Token !== undefined) {
      this.$bti.GetRefreshToken({}).then((r) => {
        if (r.code === 1) {
          this.$store.commit("saveToken", r.token);
          //如果不是ip免登录用户
          let userid = this.jwt_decode(window.localStorage.Token).userId;
          if (userid != '13400000001') {
            this.accountShow = true;
          }
          //this.userImg = this.http.ipAddress + this.jwt_decode(window.localStorage.Token).headImageUrl.substring(1);
        } else {
          console.log(r.info);
        }
      })
    }
    if (this.$route.query.token != undefined) {
      var token = this.$route.query.token;
      if (this.jwt_decode(token).orgId == this.http.GetOrgInfo().OrgId) {
        this.$store.commit("saveToken", token);

        this.$notify({
          type: "success",
          message: "welcome," + this.jwt_decode(token).tel + "",
          duration: 3000,
        });
      }
    }
    if (this.http.GetOrgInfo().Cover) {
      this.logoImage = this.$bti.ServerUrl + this.http.GetOrgInfo().Cover;
    }
    this.logoTitle = this.http.GetOrgInfo().OrgName;
    document.title = this.logoTitle;

    // this.loadColumnData();
    if (window.localStorage.Token && window.localStorage.Token.length >= 128) {
      this.userLogin = false;
    } else {
      this.userLogin = true;
    }
  },
  created: function () {
    if (this.keys == undefined) {
      this.value = "";
    } else {
      this.value = this.keys;
    }
    if (this.word != undefined) {
      this.inputvalue = this.word;
    }
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  methods: {
    loadColumnData: function () {
      this.$bti.GetColumnList({ TERMINALTYPE: 2, ISHEAD: 1, ORGID: this.http.GetOrgInfo().OrgId }).then((res) => {
        this.list.push(...res.data);// .filter(p => p.ISHEAD == 1)
      });
    },
    accountOptionList: function () {
      this.accountShow = this.accountShow === false;
    },
    goSearch: function () {
      // alert(this.$refs.searchTxt.value.trim())
      // if (this.$refs.searchTxt.value.trim()=='') {
      //   this.$message({
      //     message: "请输入关键词！",
      //     type: "warning",
      //   });
      //   return;
      // }
      if (this.$route.path.toUpperCase() === "/SEARCH".toUpperCase()) {
        this.$parent.searchData(
          this.$refs.myselected.selected.value,
          this.$refs.searchTxt.value
        );
      } else {
        this.$router.push(
          "/search?Key=" +
          this.$refs.myselected.selected.value +
          "&Word=" +
          this.$refs.searchTxt.value
        );
      }
    },
    quitLogin: function () {
      this.userLogin = true;
      this.$store.commit("saveToken", "");
      window.location.href = "/login";
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/common/head/Head.vue